module.exports = __webpack_public_path__ + "img/design@2x.46b03b3.jpg";